import React from 'react'
import DeactivateVirtualCard from 'src/app/DeactivateVirtualCard/DeactivateVirtualCard'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { deactivateVirtualCardRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const DeactivateVirtualCardAppRoute: AppRoute = {
  id: AppLocation.DeactivateVirtualCard,
  routeProps: deactivateVirtualCardRouteProps,
  component: <DeactivateVirtualCard />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default DeactivateVirtualCardAppRoute
